import { render } from "./NewInHouseCustomer.vue?vue&type=template&id=0f136835"
import script from "./NewInHouseCustomer.vue?vue&type=script&lang=js"
export * from "./NewInHouseCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__